import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";
import AdminLayout from "../layout/AdminLayout";

function Error403() {
  return (
    <AdminLayout>
      <Helmet>
        <title>Authorization denied - Digital CMS</title>
      </Helmet>

      <div className="main-content app-content">
        <div className="container-fluid">
          {/* <!-- Page Header --> */}
          <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
            <h1 className="page-title fw-semibold fs-18 mb-0">Authorization denied!</h1>
          </div>
          {/* <!-- Page Header Close --> */}

          {/* <!-- Start::row-1 --> */}
          <div className="row">
            <div className="col-xl-12">
              <div className="card custom-card">
                <div className="card-body">
                  <p className="text-danger">You don't have enough authorization to access this page!</p>
                </div>
              </div>
            </div>
          </div>
          {/* <!--End::row-1 --> */}
        </div>
      </div>

      <Helmet></Helmet>
    </AdminLayout>
  );
}

export default Error403;
